import React from 'react';
import PropTypes from 'prop-types';

const AbsolutePosition = (props) => {
  const { children, nodeRef } = props;
  const style = {
    position: 'absolute',
    top: props.top,
    // bottom: props.bottom,
    left: props.left,
    // right: props.right,
    width: props.width,
  };

  return (
    <div style={style} className={props.className} ref={nodeRef}>
      {children}
    </div>
  );
};

AbsolutePosition.propTypes = {
  top: PropTypes.number,
  bottom: PropTypes.number,
  left: PropTypes.number,
  right: PropTypes.number,
  width: PropTypes.number,
  nodeRef: PropTypes.func,
  className: PropTypes.string,
};

AbsolutePosition.defaultProps = {
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  width: 300,
  nodeRef: () => {},
  className: '',
};

export default AbsolutePosition;
